module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0004.6b1ec8fa.jpg";